// Los navegadores embebidos de Facebook/Instagram (WebViews que abren los
// links compartidos dentro de esas apps) bloquean o restringen la descarga
// de archivos vía el atributo download/blob/data URI — por eso un botón de
// descarga que funciona perfecto en Chrome/Safari no hace nada ahí. La
// solución que ya usan los clientes a mano (un banner con target="_blank")
// funciona porque ESE click real sobre un <a target="_blank"> hace que el
// WebView entregue la navegación al navegador real del sistema en vez de
// abrir otra pestaña interna — acá se automatiza el mismo truco.

export function esNavegadorEmbebido() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || navigator.vendor || "";
  // FBAN/FBAV: app de Facebook. FB_IAB: navegador interno de Facebook en
  // general (ej. abierto desde Messenger). Instagram: su propio WebView.
  return /FBAN|FBAV|FB_IAB|Instagram/i.test(ua);
}

// Abre `url` (por defecto la página actual) en el navegador real del
// sistema, replicando el click de un <a target="_blank"> real — no se
// puede usar window.open() solo porque algunos WebViews lo interceptan
// igual que una navegación normal; el <a> con click() real es el mismo
// mecanismo que ya usan los banners manuales y es el que efectivamente
// logra escapar del WebView.
export function abrirEnNavegadorExterno(url) {
  const link = document.createElement("a");
  link.href = url || window.location.href;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
